import { render, staticRenderFns } from "./TypographyList.vue?vue&type=template&id=d74ad3c4&"
import script from "./TypographyList.vue?vue&type=script&lang=js&"
export * from "./TypographyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports